var map = {
	"./en-GB.png": 7645,
	"./en.png": 1768,
	"./et.png": 9614,
	"./icons/Map.svg": 9403,
	"./icons/SiteIcon": 4876,
	"./icons/SiteIcon.tsx": 4876,
	"./icons/account.svg": 44,
	"./icons/appStore.svg": 1885,
	"./icons/arrowRight.svg": 5031,
	"./icons/battery.svg": 4767,
	"./icons/billing.svg": 5773,
	"./icons/chargerAvailable.svg": 8153,
	"./icons/chargerCharging.svg": 371,
	"./icons/chargerNotAvailable.svg": 4370,
	"./icons/chargerOff.svg": 1619,
	"./icons/chargerOn.svg": 7633,
	"./icons/charging.svg": 3694,
	"./icons/check.svg": 4097,
	"./icons/connectors/ccs.svg": 3625,
	"./icons/connectors/chademo.svg": 933,
	"./icons/connectors/type1.svg": 9893,
	"./icons/connectors/type2.svg": 1189,
	"./icons/connectors/unknown.svg": 7796,
	"./icons/cost.svg": 1558,
	"./icons/costBlack.svg": 6116,
	"./icons/costPrimary.svg": 2258,
	"./icons/down.svg": 192,
	"./icons/emptyFace.svg": 1015,
	"./icons/energySupplied.svg": 6241,
	"./icons/energySuppliedPrimary.svg": 6546,
	"./icons/exit.svg": 3101,
	"./icons/exitWithBackground.svg": 5292,
	"./icons/eye.svg": 7523,
	"./icons/feedbackIcon.svg": 4956,
	"./icons/google.svg": 7584,
	"./icons/googlePlay.svg": 1696,
	"./icons/hamburgerMenu.svg": 4778,
	"./icons/info.svg": 4792,
	"./icons/invoice.svg": 7549,
	"./icons/invoiceDownload.svg": 4258,
	"./icons/logout.svg": 3336,
	"./icons/paymentCardIcon.svg": 5814,
	"./icons/payments/americanExpress.svg": 9618,
	"./icons/payments/applePay.svg": 9332,
	"./icons/payments/googlePay.svg": 9484,
	"./icons/payments/mastercard.svg": 433,
	"./icons/payments/unionPay.svg": 5078,
	"./icons/payments/visa.svg": 1790,
	"./icons/profit.svg": 1506,
	"./icons/roadMap.png": 2615,
	"./icons/satelliteMap.png": 8835,
	"./icons/siteMarker.svg": 2994,
	"./icons/staticMarker.svg": 3494,
	"./icons/tag.svg": 6506,
	"./icons/time.svg": 4859,
	"./icons/timePrimary.svg": 3412,
	"./icons/userLocation.svg": 3259,
	"./icons/vehicleIcon.svg": 4219,
	"./icons/vehicles/audi.png": 9382,
	"./icons/vehicles/bmw.png": 9190,
	"./icons/vehicles/cupra.png": 508,
	"./icons/vehicles/hyundai.png": 4827,
	"./icons/vehicles/kia.png": 8280,
	"./icons/vehicles/nissan.png": 6242,
	"./icons/vehicles/peugeot.png": 5749,
	"./icons/vehicles/porsche.png": 9071,
	"./icons/vehicles/renault.png": 3614,
	"./icons/vehicles/skoda.png": 6262,
	"./icons/vehicles/tesla.png": 7010,
	"./icons/vehicles/volkswagen.png": 2826,
	"./icons/vehicles/volvo.png": 4438,
	"./mastercard.png": 9668,
	"./no-image.png": 7333,
	"./ru.png": 830,
	"./tesla-in-fog-pic.png": 2218,
	"./tesla-steering-wheel-source.jpeg": 4429,
	"./visa.png": 32,
	"./vool-charger-source.jpeg": 6536,
	"./vool-orange.png": 9073,
	"./vool.jpeg": 8907
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1078;